
export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {
    // scripts here fire after init() runs


  },
};





// WEBPACK FOOTER //
// ./scripts/components/info-graphics-circles.js